<template>
  <a-modal
    :title="title"
    :visible="hidden"
    @ok="ok"
    @cancel="cancel"
    :forceRender="true"
    :destroyOnClose="true"
    :maskClosable="false"
    width="800px"
    okText="确定"
    cancelText="取消">
    <a-spin :spinning="modifyLoading">
      <a-form-model
        ref="ruleForm"
        class="create-form"
        :model="form"
        :rules="rules"
        :validateOnRuleChange="true"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="配方数量" v-if="rows.length > 0">
          {{rows.length}}
        </a-form-model-item>
        <a-form-model-item label="任务名称" prop="taskName">
          <a-input size="small" placeholder="输入任务名称" v-model="form.taskName" />
        </a-form-model-item>
        <a-form-model-item label="预计产量"  prop="forecastId">
          <a-select placeholder="选择预计生产量表" v-model="form.forecastId">
            <a-select-option v-for="item in forecast.records" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="价格来源" prop="priceSource">
          <a-select :options="priceOption" placeholder="选择价格来源" v-model="form.priceSource" />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea size="small" v-model="form.remark" placeholder="输入备注" style="height:100px" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import {nhfMixins} from '../../untils'

export default {
  mixins:[nhfMixins],
  props:{
    hidden:{
      type:Boolean,
      default:false,
    },
    rows:{
      type:Array,
      default:() =>{
        return []
      }
    },
    taskId:{
      type: String,
      default:null
    }
  },
  data(){
    return {
      modelCache:[],
      modifyLoading:false,
      forecast:{
        records:[]
      },
      form:{},
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', validator: this.validatorName,  trigger: 'blur' }],
        forecastId: [{ required: true, message: '选择预计产量', trigger: 'change' }],
        priceSource: [{ required: true, message: '选择价格来源', trigger: 'change' }],
      },
    }
  },
  computed:{
    title(){
      return this.taskId ? '编辑多配方任务' : '新建多配方任务'
    },
    priceDefault(){
      return this.form && this.form.priceSource ? this.price[this.item.priceSource - 1] : null
    },
  },

  mounted(){
    this.factoryId = window.localStorage.getItem('factoryId')
    this.forecastList()
  },

  watch:{
    hidden(val){
      if(val && this.taskId){
        this.getDetail()
      }
    },

    rows(val){
      if(val.length) {
        this.form.formulaIds = val.map(i=>i.id).join()
      }
    },

  },

  methods:{
    validatorName(rule, value, callback) {
      let reg = /\s\S+|S+\s|\S/;
      const {taskName} = this.form
      if (!taskName || value.length == 0 || !reg.test(value)) {
        callback(new Error("请输入配方名称"))
      }
      callback()
    },
   async getDetail(){
      const res = await this.fetchGet({
        actions:this.formulaSpeedTaskDetail,
        name:'details',
        data:{
          id:this.taskId,
        }
      })
      if(res && res.data) {
        this.form = res.data
      }
    },
    forecastList(){
      this.fetchGet({
        name:'forecast',
        data:{
          size:1000,
          factoryId:this.factoryId
        },
        actions:this.productionForecast,
      })
    },

    modifyTask(data){
      return this.fetchPost({
        actions: this.taskId ? this.formulataskSpeedUpdate : this.saveFormulaSpeedTask,
        data,
        loading:'modifyLoading',
      })
    },

    ok(){
      this.$refs.ruleForm.validate( async (valid) => {
        if (valid) {
          const {factoryId,staffId} = this
          const data = {factoryId,staffId,...this.form,taskName:this.form.taskName.replace(/\s*/g,"")}
          await this.modifyTask(data)
          this.$emit('ok','ok')
          this.cleanForm()
        } else {
          return false
        }
      })
    },

    cancel(){
      this.cleanForm()
      this.$emit('cancel')
    },

    cleanForm(){
      this.form = {}
    },
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .ant-form-item{
    margin-bottom: 0;
  }
  ::v-deep .ant-space-item{
      font-size: 12px;
  }
</style>
